var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"videoPlayerContainer"},[_c('video-player',{ref:"videoPlayer",staticClass:"video-player vjs-custom-skin vjs-16-9",attrs:{"playsinline":false,"options":_vm.playerOptions},on:{"timeupdate":_vm.timeupdate,"loadeddata":function($event){return _vm.onPlayerLoadeddata($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }